/** @format */

import { useNavigate, Link, useLocation } from "react-router-dom";
import styles from "./AuthSidebar.module.scss";
import { toAbsoluteUrl } from "../../utils";
import { useTranslation } from "react-i18next";
import TermsModal from "../TermsModal";

const AuthSidebar = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const isTerms = location.pathname.endsWith("/terms");
  const isPrivacy = location.pathname.endsWith("/privacy");
  const open = isTerms || isPrivacy;
  const navigate = useNavigate();

  function handleClose() {
    if (location.pathname.includes("signup")) {
      navigate("/signup");
    } else {
      navigate("/");
    }
  }
  return (
    <>
      <div
        className={styles.authSidebar}
        style={{ backgroundImage: `url(${"/images/login-left-bg.png"})` }}
      >
        <figure className={styles.sidebarLogo}>
          <img
            src={toAbsoluteUrl("/images/voicegainLogo.png")}
            alt="voicegainLogo"
          />
          <b>{t("Speech-to-Text that works")}</b>
        </figure>
        <div className={styles.sidebarContentWrapper}>
          <div className={styles.sidebarContent}>
            <h2>{t("Voice AI for Business")}</h2>
            <h6>
              {t(
                "Use APIs to embed transcription into your App. Use Transcribe App as an AI meeting assistant or to transcribe audio content."
              )}
            </h6>
          </div>
        </div>
        <div className={styles.appSelectorBtnArea}>
          <Link className={styles.linkButton} to="terms">
            {t("Terms and Conditions")}
          </Link>
          <Link className={styles.linkButton} to="privacy">
            {t("Privacy Policy")}
          </Link>
        </div>
      </div>
      <TermsModal
        open={open}
        onClose={handleClose}
        isTerms={isTerms}
        isPrivacy={isPrivacy}
      />
    </>
  );
};

export default AuthSidebar;
